type VDIItem = {
  sku: string;
  cpu: string;
  memory: string;
  user_disk: string;
  pricing: {
    linux: string;
    windows: string;
  };
};

type VDIData = {
  heading: string;
  data: VDIItem[];
  footer?: boolean;
};

export const ORGANIZATION_SERVER: VDIData = {
  heading: "Dedicated Server for Organization (For 10+ Users)",
  data: [
    {
      sku: "S-CD1",
      cpu: "2",
      memory: "4GB",
      user_disk: "20GB",
      pricing: {
        linux: "$22",
        windows: "$30",
      },
    },
    {
      sku: "S-CD2",
      cpu: "4",
      memory: "8GB",
      user_disk: "40GB",
      pricing: {
        linux: "$30",
        windows: "$38",
      },
    },
    {
      sku: "S-CD3",
      cpu: "8",
      memory: "16GB",
      user_disk: "100GB",
      pricing: {
        linux: "$42",
        windows: "$51",
      },
    },
    {
      sku: "S-CD4",
      cpu: "2",
      memory: "8GB",
      user_disk: "40GB",
      pricing: {
        linux: "$26",
        windows: "$34",
      },
    },
    {
      sku: "S-CD5",
      cpu: "4",
      memory: "16GB",
      user_disk: "100GB",
      pricing: {
        linux: "$36",
        windows: "$44",
      },
    },
    {
      sku: "S-CD6",
      cpu: "8",
      memory: "32GB",
      user_disk: "100GB",
      pricing: {
        linux: "$54",
        windows: "$63",
      },
    },
  ],
  footer: true,
};

export const USER_SERVER: VDIData = {
  heading: "Dedicated VM Minimum 10 user (1:1 VM)",
  data: [
    {
      sku: "D-CD1",
      cpu: "2",
      memory: "4GB",
      user_disk: "20GB",
      pricing: {
        linux: "$36",
        windows: "$44",
      },
    },
    {
      sku: "D-CD2",
      cpu: "4",
      memory: "8GB",
      user_disk: "40GB",
      pricing: {
        linux: "$58",
        windows: "$65",
      },
    },
    {
      sku: "D-CD3",
      cpu: "8",
      memory: "16GB",
      user_disk: "100GB",
      pricing: {
        linux: "$120",
        windows: "$128",
      },
    },
    {
      sku: "D-CD4",
      cpu: "2",
      memory: "8GB",
      user_disk: "40GB",
      pricing: {
        linux: "$62",
        windows: "$69",
      },
    },
    {
      sku: "D-CD5",
      cpu: "4",
      memory: "16GB",
      user_disk: "100GB",
      pricing: {
        linux: "$112",
        windows: "$119",
      },
    },
    {
      sku: "D-CD6",
      cpu: "8",
      memory: "32GB",
      user_disk: "100GB",
      pricing: {
        linux: "$187",
        windows: "$194",
      },
    },
  ],
  footer: true,
};

export const FOOTER_CONSTANTS = {
  btnText: "Test Drive our VDI Solution",
};
